module.exports = {
  isTypeOf: require('./is-type-of'),
  isInstanceOf: require('./is-instance-of'),
  isEmail: require('./is-email')
};